export const shipmentPiece = {
  weight: 0,
  length: 0,
  width: 0,
  height: 0,
  volWt: 0,
  gtip: '',
  content: '',
  currencyValue: 0,
  reference: '',
  priceableWeight: 0,
  volumetricWeight: 0,
  volume: 0,
  piece: 0,
  containerTypeId: '',
  pieceOfProducts: [{ description: '', gtip: '', amount: 0, price: 0 }],
};

export const pieceOfProduct = {
  description: '',
  gtip: '',
  amount: 0,
  price: 0,
};

export const emptyInsurance = {
  price: '',
  currencyNameId: '',
};
